import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgYoutubeCircle = function SvgYoutubeCircle(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 512C0 229.2 229.2 0 512 0s512 229.2 512 512-229.2 512-512 512S0 794.8 0 512m773.7-126.4c-6.3-24.1-24.8-43.1-48.3-49.6-42.6-11.7-213.4-11.7-213.4-11.7s-170.8 0-213.4 11.7c-23.5 6.4-42 25.4-48.3 49.6-11.4 43.7-11.4 135-11.4 135s0 91.2 11.4 135c6.3 24.1 24.8 43.1 48.3 49.6 42.6 11.6 213.4 11.6 213.4 11.6s170.8 0 213.4-11.7c23.5-6.5 42-25.5 48.3-49.6 11.4-43.7 11.4-135 11.4-135s0-91.2-11.4-134.9M469.3 597.3V426.7L605.9 512z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgYoutubeCircle);

export { ForwardRef as default };
